import type { Zone } from '@/lib/zones';

export type Outcome = 'goal' | 'saved' | 'off';

/**
 * Resolve a single shot per spec §2.4.
 * - actualZone === 'off' → 'off' (post/wide due to swipe noise)
 * - actualZone === keeperZone → 'saved'
 * - otherwise → 'goal'
 */
export function resolveShot(
  actualZone: Zone | 'off',
  keeperZone: Zone,
): Outcome {
  if (actualZone === 'off') return 'off';
  if (actualZone === keeperZone) return 'saved';
  return 'goal';
}
